import { DateRangePicker } from 'app/ComponentLibrary/DateRangeNew';
import { isNullOrUndefined } from 'app/helpers/objectHelpers';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { usePromiseTracker } from 'react-promise-tracker';
import { useSelector } from 'react-redux';
import {
  selectApprovalStatusSelected,
  selectIsEditMod,
  selectStandard,
} from 'store/redux-store/placement-mods/selectors';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()(theme => ({
  inputFields: {
    minWidth: '215px',
    '& .MuiFilledInput-input': {
      height: '2em',
    },
  },
}));
export const DueDate = ({ readOnly }: { readOnly?: boolean }) => {
  const { classes } = useStyles();
  const { control, formState: { errors }, setError, clearErrors } = useFormContext();
  const value: Date | string | null | undefined = useWatch({ name: 'dateDue' });
  const isModEdit = useSelector(selectIsEditMod);
  const standard = useSelector(selectStandard);
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const isApprovalStatusSelected = useSelector(selectApprovalStatusSelected);
  const [isDateRequired, setDateRequired] = useState<boolean>(false);

  useEffect(() => {
    // If readOnly is true, don't require the date
    if (readOnly) {
      clearErrors('dateDue');
      setDateRequired(false);
    } else if (isApprovalStatusSelected && value == null && standard === false) {
      setError('dateDue', {});
      setDateRequired(true);
    } else {
      clearErrors('dateDue');
      setDateRequired(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isApprovalStatusSelected, standard, value, isDateRequired, readOnly]);
  return (
    <Controller
      control={control}
      name={'dateDue'}
      rules={{
        required: isDateRequired,
      }}
      render={({ field: { onChange, value, ...rest } }) => {
        const dateDue = moment(value ?? null);
        return (
          <React.Fragment>
            <DateRangePicker
              onChange={newValue => {
                if (newValue.startDate !== undefined) {
                  const newDate = moment(newValue.startDate);
                  const setTo = newDate.isValid() ? moment(newDate).format('YYYY-MM-DDTHH:mm:ss') : null;
                  onChange(setTo);
                  clearErrors('dateDue');
                } else {
                  onChange(null);
                  setError('dateDue', {});
                }
              }}
              readOnly={readOnly || standard ? true : !isModEdit}
              isDisabled={isSaveModApiCalling}
              value={value}
              quickSelect={false}
              clear
              open={false}
              variant="filled"
              single
              placeholder={`Due Date ${isDateRequired ? '*' : ''}`}
              useMaxWidth={true}
              showIcon={true}
              className={classes.inputFields}
              labelClass={classes.inputFields}
              actionBar={false}
              clickAway={true}
              trailingIconShow={true}
              keepClickAwayVal={false}
              initialDateRange={{
                startDate: dateDue.isValid() ? new Date(dateDue.format('YYYY-MM-DDTHH:mm:ss')) : undefined,
                endDate: dateDue.isValid() ? new Date(dateDue.format('YYYY-MM-DDTHH:mm:ss')) : undefined,
                useLabelAsValue: true,
              }}
              {...rest}
              error={!isNullOrUndefined(errors?.dateDue)}
              helperText={!isNullOrUndefined(errors?.dateDue) ? 'Required' : undefined}
            />
          </React.Fragment>
        );
      }}
    />
  );
};
